import { ColoursObj, TEventrIcons } from '@eventr/common-storybook'
import { CardText } from './cardText'
import { ColouredIcon } from './colouredIcon'
import { RowInfo } from './rowInfo'

interface RowInfoStandartProps {
    bubbleColour?: string
    icon?: TEventrIcons
    middle?: string
    end?: string
}

export const RowInfoStandart = ({
    bubbleColour = ColoursObj.coreBrights.secondary,
    icon = 'Free_Edit',
    middle,
    end,
}: RowInfoStandartProps) => {
    return (
        <RowInfo
            start={
                <ColouredIcon
                    name={icon as any}
                    bubble
                    bubbleColour={bubbleColour}
                />
            }
            middle={<CardText useMarkdown>{middle}</CardText>}
            end={<CardText>{end}</CardText>}
        />
    )
}
